var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25H6.75001C5.34808 5.25 4.64711 5.25 4.125 5.55145C3.78296 5.74892 3.49893 6.03296 3.30145 6.37499C3 6.89711 3 7.5981 3 9C3 10.4019 3 11.1028 3.30144 11.625C3.49892 11.9671 3.78295 12.2511 4.125 12.4486C4.64711 12.75 5.34808 12.75 6.75 12.75H12M15 5.25L12.75 3M15 5.25L12.75 7.5",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.1db2cd23ad3f9252e56d24522d7b3fcf.svg";
export { ForwardRef as ReactComponent };